import { ReactNode } from 'react';

import { Text } from '@ui';

export const SidebarSectionTitle = ({ children }: { children: ReactNode }) => {
    return <Text className="font-b mb-m text-l">{children}</Text>;
};
